import { render } from "./SwitchComponent.vue?vue&type=template&id=2d583f5f&scoped=true"
import script from "./SwitchComponent.vue?vue&type=script&lang=js"
export * from "./SwitchComponent.vue?vue&type=script&lang=js"

import "./SwitchComponent.vue?vue&type=style&index=0&id=2d583f5f&scoped=true&lang=css"

import exportComponent from "/var/www/spom.vh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d583f5f"]])

export default __exports__